








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../../../mti/metadata_pb.js');
var mti_store_cable_state_pb=require('../../../mti/store/cable/state_pb.js');
var mti_store_lock_state_pb=require('../../../mti/store/lock/state_pb.js');
var google_protobuf_timestamp_pb=require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.mti.store.fm_20.State',null,global);











proto.mti.store.fm_20.State=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.fm_20.State,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.fm_20.State.displayName='proto.mti.store.fm_20.State';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.fm_20.State.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.fm_20.State.toObject(opt_includeInstance,this);
};











proto.mti.store.fm_20.State.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
storeId:jspb.Message.getFieldWithDefault(msg,2,0),
stateUuid:msg.getStateUuid_asB64(),
stateUpdatedAt:(f=msg.getStateUpdatedAt())&&google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance,f),
puckSerialNumber:jspb.Message.getFieldWithDefault(msg,5,""),
baseSerialNumber:jspb.Message.getFieldWithDefault(msg,6,""),
cableType:jspb.Message.getFieldWithDefault(msg,7,0),
puckBatteryLevel:jspb.Message.getFieldWithDefault(msg,8,0),
baseBatteryLevel:jspb.Message.getFieldWithDefault(msg,9,0),
keySerialNumber:jspb.Message.getFieldWithDefault(msg,10,""),
keyType:jspb.Message.getFieldWithDefault(msg,11,0),
puckLostCommunication:jspb.Message.getFieldWithDefault(msg,12,false),
puckIdentifying:jspb.Message.getFieldWithDefault(msg,13,false),
puckCharging:jspb.Message.getFieldWithDefault(msg,14,false),
puckPowered:jspb.Message.getFieldWithDefault(msg,15,false),
puckDeepSleep:jspb.Message.getFieldWithDefault(msg,16,false),
puckShutdown:jspb.Message.getFieldWithDefault(msg,17,false),
puckLifted:jspb.Message.getFieldWithDefault(msg,18,false),
tetherDisconnected:jspb.Message.getFieldWithDefault(msg,19,false),
puckSwitchOpen:jspb.Message.getFieldWithDefault(msg,48,false),
baseLostCommunication:jspb.Message.getFieldWithDefault(msg,20,false),
baseCharging:jspb.Message.getFieldWithDefault(msg,21,false),
basePowered:jspb.Message.getFieldWithDefault(msg,22,false),
baseShutdown:jspb.Message.getFieldWithDefault(msg,23,false),
baseOutputDisabled:jspb.Message.getFieldWithDefault(msg,24,false),
baseOutputOvercurrent:jspb.Message.getFieldWithDefault(msg,25,false),
baseButtonLifted:jspb.Message.getFieldWithDefault(msg,26,false),
baseMotorUnlocked:jspb.Message.getFieldWithDefault(msg,27,false),
baseMotorStuck:jspb.Message.getFieldWithDefault(msg,28,false),
puckLatched:jspb.Message.getFieldWithDefault(msg,49,false),
armed:jspb.Message.getFieldWithDefault(msg,29,false),
authorizedUserKeyUsed:jspb.Message.getFieldWithDefault(msg,30,false),
silentAlarming:jspb.Message.getFieldWithDefault(msg,31,false),
puckSwitchAlarming:jspb.Message.getFieldWithDefault(msg,32,false),
tetherAlarming:jspb.Message.getFieldWithDefault(msg,33,false),
baseLiftAlarming:jspb.Message.getFieldWithDefault(msg,34,false),
cableAlarming:jspb.Message.getFieldWithDefault(msg,35,false),
deviceAlarming:jspb.Message.getFieldWithDefault(msg,36,false),
deviceAltAlarming:jspb.Message.getFieldWithDefault(msg,37,false),
deviceLostCommunication:jspb.Message.getFieldWithDefault(msg,38,false),
deviceAltLostCommunication:jspb.Message.getFieldWithDefault(msg,39,false),
deviceCharging:jspb.Message.getFieldWithDefault(msg,40,false),
deviceOvercurrent:jspb.Message.getFieldWithDefault(msg,41,false),
puckModel:jspb.Message.getFieldWithDefault(msg,42,""),
puckHardwareVersion:jspb.Message.getFieldWithDefault(msg,43,""),
puckFirmwareVersion:jspb.Message.getFieldWithDefault(msg,44,""),
baseModel:jspb.Message.getFieldWithDefault(msg,45,""),
baseHardwareVersion:jspb.Message.getFieldWithDefault(msg,46,""),
baseFirmwareVersion:jspb.Message.getFieldWithDefault(msg,47,"")};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.fm_20.State.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.fm_20.State();
return proto.mti.store.fm_20.State.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.fm_20.State.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 3:
var value=reader.readBytes();
msg.setStateUuid(value);
break;
case 4:
var value=new google_protobuf_timestamp_pb.Timestamp();
reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
msg.setStateUpdatedAt(value);
break;
case 5:
var value=reader.readString();
msg.setPuckSerialNumber(value);
break;
case 6:
var value=reader.readString();
msg.setBaseSerialNumber(value);
break;
case 7:
var value=reader.readEnum();
msg.setCableType(value);
break;
case 8:
var value=reader.readUint32();
msg.setPuckBatteryLevel(value);
break;
case 9:
var value=reader.readUint32();
msg.setBaseBatteryLevel(value);
break;
case 10:
var value=reader.readString();
msg.setKeySerialNumber(value);
break;
case 11:
var value=reader.readEnum();
msg.setKeyType(value);
break;
case 12:
var value=reader.readBool();
msg.setPuckLostCommunication(value);
break;
case 13:
var value=reader.readBool();
msg.setPuckIdentifying(value);
break;
case 14:
var value=reader.readBool();
msg.setPuckCharging(value);
break;
case 15:
var value=reader.readBool();
msg.setPuckPowered(value);
break;
case 16:
var value=reader.readBool();
msg.setPuckDeepSleep(value);
break;
case 17:
var value=reader.readBool();
msg.setPuckShutdown(value);
break;
case 18:
var value=reader.readBool();
msg.setPuckLifted(value);
break;
case 19:
var value=reader.readBool();
msg.setTetherDisconnected(value);
break;
case 48:
var value=reader.readBool();
msg.setPuckSwitchOpen(value);
break;
case 20:
var value=reader.readBool();
msg.setBaseLostCommunication(value);
break;
case 21:
var value=reader.readBool();
msg.setBaseCharging(value);
break;
case 22:
var value=reader.readBool();
msg.setBasePowered(value);
break;
case 23:
var value=reader.readBool();
msg.setBaseShutdown(value);
break;
case 24:
var value=reader.readBool();
msg.setBaseOutputDisabled(value);
break;
case 25:
var value=reader.readBool();
msg.setBaseOutputOvercurrent(value);
break;
case 26:
var value=reader.readBool();
msg.setBaseButtonLifted(value);
break;
case 27:
var value=reader.readBool();
msg.setBaseMotorUnlocked(value);
break;
case 28:
var value=reader.readBool();
msg.setBaseMotorStuck(value);
break;
case 49:
var value=reader.readBool();
msg.setPuckLatched(value);
break;
case 29:
var value=reader.readBool();
msg.setArmed(value);
break;
case 30:
var value=reader.readBool();
msg.setAuthorizedUserKeyUsed(value);
break;
case 31:
var value=reader.readBool();
msg.setSilentAlarming(value);
break;
case 32:
var value=reader.readBool();
msg.setPuckSwitchAlarming(value);
break;
case 33:
var value=reader.readBool();
msg.setTetherAlarming(value);
break;
case 34:
var value=reader.readBool();
msg.setBaseLiftAlarming(value);
break;
case 35:
var value=reader.readBool();
msg.setCableAlarming(value);
break;
case 36:
var value=reader.readBool();
msg.setDeviceAlarming(value);
break;
case 37:
var value=reader.readBool();
msg.setDeviceAltAlarming(value);
break;
case 38:
var value=reader.readBool();
msg.setDeviceLostCommunication(value);
break;
case 39:
var value=reader.readBool();
msg.setDeviceAltLostCommunication(value);
break;
case 40:
var value=reader.readBool();
msg.setDeviceCharging(value);
break;
case 41:
var value=reader.readBool();
msg.setDeviceOvercurrent(value);
break;
case 42:
var value=reader.readString();
msg.setPuckModel(value);
break;
case 43:
var value=reader.readString();
msg.setPuckHardwareVersion(value);
break;
case 44:
var value=reader.readString();
msg.setPuckFirmwareVersion(value);
break;
case 45:
var value=reader.readString();
msg.setBaseModel(value);
break;
case 46:
var value=reader.readString();
msg.setBaseHardwareVersion(value);
break;
case 47:
var value=reader.readString();
msg.setBaseFirmwareVersion(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.fm_20.State.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.fm_20.State.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.fm_20.State.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getStateUuid_asU8();
if(f.length>0){
writer.writeBytes(
3,
f);

}
f=message.getStateUpdatedAt();
if(f!=null){
writer.writeMessage(
4,
f,
google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);

}
f=message.getPuckSerialNumber();
if(f.length>0){
writer.writeString(
5,
f);

}
f=message.getBaseSerialNumber();
if(f.length>0){
writer.writeString(
6,
f);

}
f=message.getCableType();
if(f!==0.0){
writer.writeEnum(
7,
f);

}
f=message.getPuckBatteryLevel();
if(f!==0){
writer.writeUint32(
8,
f);

}
f=message.getBaseBatteryLevel();
if(f!==0){
writer.writeUint32(
9,
f);

}
f=message.getKeySerialNumber();
if(f.length>0){
writer.writeString(
10,
f);

}
f=message.getKeyType();
if(f!==0.0){
writer.writeEnum(
11,
f);

}
f=message.getPuckLostCommunication();
if(f){
writer.writeBool(
12,
f);

}
f=message.getPuckIdentifying();
if(f){
writer.writeBool(
13,
f);

}
f=message.getPuckCharging();
if(f){
writer.writeBool(
14,
f);

}
f=message.getPuckPowered();
if(f){
writer.writeBool(
15,
f);

}
f=message.getPuckDeepSleep();
if(f){
writer.writeBool(
16,
f);

}
f=message.getPuckShutdown();
if(f){
writer.writeBool(
17,
f);

}
f=message.getPuckLifted();
if(f){
writer.writeBool(
18,
f);

}
f=message.getTetherDisconnected();
if(f){
writer.writeBool(
19,
f);

}
f=message.getPuckSwitchOpen();
if(f){
writer.writeBool(
48,
f);

}
f=message.getBaseLostCommunication();
if(f){
writer.writeBool(
20,
f);

}
f=message.getBaseCharging();
if(f){
writer.writeBool(
21,
f);

}
f=message.getBasePowered();
if(f){
writer.writeBool(
22,
f);

}
f=message.getBaseShutdown();
if(f){
writer.writeBool(
23,
f);

}
f=message.getBaseOutputDisabled();
if(f){
writer.writeBool(
24,
f);

}
f=message.getBaseOutputOvercurrent();
if(f){
writer.writeBool(
25,
f);

}
f=message.getBaseButtonLifted();
if(f){
writer.writeBool(
26,
f);

}
f=message.getBaseMotorUnlocked();
if(f){
writer.writeBool(
27,
f);

}
f=message.getBaseMotorStuck();
if(f){
writer.writeBool(
28,
f);

}
f=message.getPuckLatched();
if(f){
writer.writeBool(
49,
f);

}
f=message.getArmed();
if(f){
writer.writeBool(
29,
f);

}
f=message.getAuthorizedUserKeyUsed();
if(f){
writer.writeBool(
30,
f);

}
f=message.getSilentAlarming();
if(f){
writer.writeBool(
31,
f);

}
f=message.getPuckSwitchAlarming();
if(f){
writer.writeBool(
32,
f);

}
f=message.getTetherAlarming();
if(f){
writer.writeBool(
33,
f);

}
f=message.getBaseLiftAlarming();
if(f){
writer.writeBool(
34,
f);

}
f=message.getCableAlarming();
if(f){
writer.writeBool(
35,
f);

}
f=message.getDeviceAlarming();
if(f){
writer.writeBool(
36,
f);

}
f=message.getDeviceAltAlarming();
if(f){
writer.writeBool(
37,
f);

}
f=message.getDeviceLostCommunication();
if(f){
writer.writeBool(
38,
f);

}
f=message.getDeviceAltLostCommunication();
if(f){
writer.writeBool(
39,
f);

}
f=message.getDeviceCharging();
if(f){
writer.writeBool(
40,
f);

}
f=message.getDeviceOvercurrent();
if(f){
writer.writeBool(
41,
f);

}
f=message.getPuckModel();
if(f.length>0){
writer.writeString(
42,
f);

}
f=message.getPuckHardwareVersion();
if(f.length>0){
writer.writeString(
43,
f);

}
f=message.getPuckFirmwareVersion();
if(f.length>0){
writer.writeString(
44,
f);

}
f=message.getBaseModel();
if(f.length>0){
writer.writeString(
45,
f);

}
f=message.getBaseHardwareVersion();
if(f.length>0){
writer.writeString(
46,
f);

}
f=message.getBaseFirmwareVersion();
if(f.length>0){
writer.writeString(
47,
f);

}
};






proto.mti.store.fm_20.State.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.store.fm_20.State.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.store.fm_20.State.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.store.fm_20.State.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.store.fm_20.State.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.store.fm_20.State.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.store.fm_20.State.prototype.getStateUuid=function(){
return jspb.Message.getFieldWithDefault(this,3,"");
};







proto.mti.store.fm_20.State.prototype.getStateUuid_asB64=function(){
return jspb.Message.bytesAsB64(
this.getStateUuid());
};









proto.mti.store.fm_20.State.prototype.getStateUuid_asU8=function(){
return jspb.Message.bytesAsU8(
this.getStateUuid());
};



proto.mti.store.fm_20.State.prototype.setStateUuid=function(value){
jspb.Message.setProto3BytesField(this,3,value);
};






proto.mti.store.fm_20.State.prototype.getStateUpdatedAt=function(){
return(
jspb.Message.getWrapperField(this,google_protobuf_timestamp_pb.Timestamp,4));
};



proto.mti.store.fm_20.State.prototype.setStateUpdatedAt=function(value){
jspb.Message.setWrapperField(this,4,value);
};


proto.mti.store.fm_20.State.prototype.clearStateUpdatedAt=function(){
this.setStateUpdatedAt(undefined);
};






proto.mti.store.fm_20.State.prototype.hasStateUpdatedAt=function(){
return jspb.Message.getField(this,4)!=null;
};






proto.mti.store.fm_20.State.prototype.getPuckSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,5,"");
};



proto.mti.store.fm_20.State.prototype.setPuckSerialNumber=function(value){
jspb.Message.setProto3StringField(this,5,value);
};






proto.mti.store.fm_20.State.prototype.getBaseSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,6,"");
};



proto.mti.store.fm_20.State.prototype.setBaseSerialNumber=function(value){
jspb.Message.setProto3StringField(this,6,value);
};






proto.mti.store.fm_20.State.prototype.getCableType=function(){
return jspb.Message.getFieldWithDefault(this,7,0);
};



proto.mti.store.fm_20.State.prototype.setCableType=function(value){
jspb.Message.setProto3EnumField(this,7,value);
};






proto.mti.store.fm_20.State.prototype.getPuckBatteryLevel=function(){
return jspb.Message.getFieldWithDefault(this,8,0);
};



proto.mti.store.fm_20.State.prototype.setPuckBatteryLevel=function(value){
jspb.Message.setProto3IntField(this,8,value);
};






proto.mti.store.fm_20.State.prototype.getBaseBatteryLevel=function(){
return jspb.Message.getFieldWithDefault(this,9,0);
};



proto.mti.store.fm_20.State.prototype.setBaseBatteryLevel=function(value){
jspb.Message.setProto3IntField(this,9,value);
};






proto.mti.store.fm_20.State.prototype.getKeySerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,10,"");
};



proto.mti.store.fm_20.State.prototype.setKeySerialNumber=function(value){
jspb.Message.setProto3StringField(this,10,value);
};






proto.mti.store.fm_20.State.prototype.getKeyType=function(){
return jspb.Message.getFieldWithDefault(this,11,0);
};



proto.mti.store.fm_20.State.prototype.setKeyType=function(value){
jspb.Message.setProto3EnumField(this,11,value);
};








proto.mti.store.fm_20.State.prototype.getPuckLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,12,false);
};



proto.mti.store.fm_20.State.prototype.setPuckLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,12,value);
};








proto.mti.store.fm_20.State.prototype.getPuckIdentifying=function(){
return jspb.Message.getFieldWithDefault(this,13,false);
};



proto.mti.store.fm_20.State.prototype.setPuckIdentifying=function(value){
jspb.Message.setProto3BooleanField(this,13,value);
};








proto.mti.store.fm_20.State.prototype.getPuckCharging=function(){
return jspb.Message.getFieldWithDefault(this,14,false);
};



proto.mti.store.fm_20.State.prototype.setPuckCharging=function(value){
jspb.Message.setProto3BooleanField(this,14,value);
};








proto.mti.store.fm_20.State.prototype.getPuckPowered=function(){
return jspb.Message.getFieldWithDefault(this,15,false);
};



proto.mti.store.fm_20.State.prototype.setPuckPowered=function(value){
jspb.Message.setProto3BooleanField(this,15,value);
};








proto.mti.store.fm_20.State.prototype.getPuckDeepSleep=function(){
return jspb.Message.getFieldWithDefault(this,16,false);
};



proto.mti.store.fm_20.State.prototype.setPuckDeepSleep=function(value){
jspb.Message.setProto3BooleanField(this,16,value);
};








proto.mti.store.fm_20.State.prototype.getPuckShutdown=function(){
return jspb.Message.getFieldWithDefault(this,17,false);
};



proto.mti.store.fm_20.State.prototype.setPuckShutdown=function(value){
jspb.Message.setProto3BooleanField(this,17,value);
};








proto.mti.store.fm_20.State.prototype.getPuckLifted=function(){
return jspb.Message.getFieldWithDefault(this,18,false);
};



proto.mti.store.fm_20.State.prototype.setPuckLifted=function(value){
jspb.Message.setProto3BooleanField(this,18,value);
};








proto.mti.store.fm_20.State.prototype.getTetherDisconnected=function(){
return jspb.Message.getFieldWithDefault(this,19,false);
};



proto.mti.store.fm_20.State.prototype.setTetherDisconnected=function(value){
jspb.Message.setProto3BooleanField(this,19,value);
};








proto.mti.store.fm_20.State.prototype.getPuckSwitchOpen=function(){
return jspb.Message.getFieldWithDefault(this,48,false);
};



proto.mti.store.fm_20.State.prototype.setPuckSwitchOpen=function(value){
jspb.Message.setProto3BooleanField(this,48,value);
};








proto.mti.store.fm_20.State.prototype.getBaseLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,20,false);
};



proto.mti.store.fm_20.State.prototype.setBaseLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,20,value);
};








proto.mti.store.fm_20.State.prototype.getBaseCharging=function(){
return jspb.Message.getFieldWithDefault(this,21,false);
};



proto.mti.store.fm_20.State.prototype.setBaseCharging=function(value){
jspb.Message.setProto3BooleanField(this,21,value);
};








proto.mti.store.fm_20.State.prototype.getBasePowered=function(){
return jspb.Message.getFieldWithDefault(this,22,false);
};



proto.mti.store.fm_20.State.prototype.setBasePowered=function(value){
jspb.Message.setProto3BooleanField(this,22,value);
};








proto.mti.store.fm_20.State.prototype.getBaseShutdown=function(){
return jspb.Message.getFieldWithDefault(this,23,false);
};



proto.mti.store.fm_20.State.prototype.setBaseShutdown=function(value){
jspb.Message.setProto3BooleanField(this,23,value);
};








proto.mti.store.fm_20.State.prototype.getBaseOutputDisabled=function(){
return jspb.Message.getFieldWithDefault(this,24,false);
};



proto.mti.store.fm_20.State.prototype.setBaseOutputDisabled=function(value){
jspb.Message.setProto3BooleanField(this,24,value);
};








proto.mti.store.fm_20.State.prototype.getBaseOutputOvercurrent=function(){
return jspb.Message.getFieldWithDefault(this,25,false);
};



proto.mti.store.fm_20.State.prototype.setBaseOutputOvercurrent=function(value){
jspb.Message.setProto3BooleanField(this,25,value);
};








proto.mti.store.fm_20.State.prototype.getBaseButtonLifted=function(){
return jspb.Message.getFieldWithDefault(this,26,false);
};



proto.mti.store.fm_20.State.prototype.setBaseButtonLifted=function(value){
jspb.Message.setProto3BooleanField(this,26,value);
};








proto.mti.store.fm_20.State.prototype.getBaseMotorUnlocked=function(){
return jspb.Message.getFieldWithDefault(this,27,false);
};



proto.mti.store.fm_20.State.prototype.setBaseMotorUnlocked=function(value){
jspb.Message.setProto3BooleanField(this,27,value);
};








proto.mti.store.fm_20.State.prototype.getBaseMotorStuck=function(){
return jspb.Message.getFieldWithDefault(this,28,false);
};



proto.mti.store.fm_20.State.prototype.setBaseMotorStuck=function(value){
jspb.Message.setProto3BooleanField(this,28,value);
};








proto.mti.store.fm_20.State.prototype.getPuckLatched=function(){
return jspb.Message.getFieldWithDefault(this,49,false);
};



proto.mti.store.fm_20.State.prototype.setPuckLatched=function(value){
jspb.Message.setProto3BooleanField(this,49,value);
};








proto.mti.store.fm_20.State.prototype.getArmed=function(){
return jspb.Message.getFieldWithDefault(this,29,false);
};



proto.mti.store.fm_20.State.prototype.setArmed=function(value){
jspb.Message.setProto3BooleanField(this,29,value);
};








proto.mti.store.fm_20.State.prototype.getAuthorizedUserKeyUsed=function(){
return jspb.Message.getFieldWithDefault(this,30,false);
};



proto.mti.store.fm_20.State.prototype.setAuthorizedUserKeyUsed=function(value){
jspb.Message.setProto3BooleanField(this,30,value);
};








proto.mti.store.fm_20.State.prototype.getSilentAlarming=function(){
return jspb.Message.getFieldWithDefault(this,31,false);
};



proto.mti.store.fm_20.State.prototype.setSilentAlarming=function(value){
jspb.Message.setProto3BooleanField(this,31,value);
};








proto.mti.store.fm_20.State.prototype.getPuckSwitchAlarming=function(){
return jspb.Message.getFieldWithDefault(this,32,false);
};



proto.mti.store.fm_20.State.prototype.setPuckSwitchAlarming=function(value){
jspb.Message.setProto3BooleanField(this,32,value);
};








proto.mti.store.fm_20.State.prototype.getTetherAlarming=function(){
return jspb.Message.getFieldWithDefault(this,33,false);
};



proto.mti.store.fm_20.State.prototype.setTetherAlarming=function(value){
jspb.Message.setProto3BooleanField(this,33,value);
};








proto.mti.store.fm_20.State.prototype.getBaseLiftAlarming=function(){
return jspb.Message.getFieldWithDefault(this,34,false);
};



proto.mti.store.fm_20.State.prototype.setBaseLiftAlarming=function(value){
jspb.Message.setProto3BooleanField(this,34,value);
};








proto.mti.store.fm_20.State.prototype.getCableAlarming=function(){
return jspb.Message.getFieldWithDefault(this,35,false);
};



proto.mti.store.fm_20.State.prototype.setCableAlarming=function(value){
jspb.Message.setProto3BooleanField(this,35,value);
};








proto.mti.store.fm_20.State.prototype.getDeviceAlarming=function(){
return jspb.Message.getFieldWithDefault(this,36,false);
};



proto.mti.store.fm_20.State.prototype.setDeviceAlarming=function(value){
jspb.Message.setProto3BooleanField(this,36,value);
};








proto.mti.store.fm_20.State.prototype.getDeviceAltAlarming=function(){
return jspb.Message.getFieldWithDefault(this,37,false);
};



proto.mti.store.fm_20.State.prototype.setDeviceAltAlarming=function(value){
jspb.Message.setProto3BooleanField(this,37,value);
};








proto.mti.store.fm_20.State.prototype.getDeviceLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,38,false);
};



proto.mti.store.fm_20.State.prototype.setDeviceLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,38,value);
};








proto.mti.store.fm_20.State.prototype.getDeviceAltLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,39,false);
};



proto.mti.store.fm_20.State.prototype.setDeviceAltLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,39,value);
};








proto.mti.store.fm_20.State.prototype.getDeviceCharging=function(){
return jspb.Message.getFieldWithDefault(this,40,false);
};



proto.mti.store.fm_20.State.prototype.setDeviceCharging=function(value){
jspb.Message.setProto3BooleanField(this,40,value);
};








proto.mti.store.fm_20.State.prototype.getDeviceOvercurrent=function(){
return jspb.Message.getFieldWithDefault(this,41,false);
};



proto.mti.store.fm_20.State.prototype.setDeviceOvercurrent=function(value){
jspb.Message.setProto3BooleanField(this,41,value);
};






proto.mti.store.fm_20.State.prototype.getPuckModel=function(){
return jspb.Message.getFieldWithDefault(this,42,"");
};



proto.mti.store.fm_20.State.prototype.setPuckModel=function(value){
jspb.Message.setProto3StringField(this,42,value);
};






proto.mti.store.fm_20.State.prototype.getPuckHardwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,43,"");
};



proto.mti.store.fm_20.State.prototype.setPuckHardwareVersion=function(value){
jspb.Message.setProto3StringField(this,43,value);
};






proto.mti.store.fm_20.State.prototype.getPuckFirmwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,44,"");
};



proto.mti.store.fm_20.State.prototype.setPuckFirmwareVersion=function(value){
jspb.Message.setProto3StringField(this,44,value);
};






proto.mti.store.fm_20.State.prototype.getBaseModel=function(){
return jspb.Message.getFieldWithDefault(this,45,"");
};



proto.mti.store.fm_20.State.prototype.setBaseModel=function(value){
jspb.Message.setProto3StringField(this,45,value);
};






proto.mti.store.fm_20.State.prototype.getBaseHardwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,46,"");
};



proto.mti.store.fm_20.State.prototype.setBaseHardwareVersion=function(value){
jspb.Message.setProto3StringField(this,46,value);
};






proto.mti.store.fm_20.State.prototype.getBaseFirmwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,47,"");
};



proto.mti.store.fm_20.State.prototype.setBaseFirmwareVersion=function(value){
jspb.Message.setProto3StringField(this,47,value);
};


goog.object.extend(exports,proto.mti.store.fm_20);